import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=d4229b78&scoped=true&lang=pug"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=d4229b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4229b78",
  null
  
)

export default component.exports